import {
  Component,
  Input,
  OnDestroy
} from '@angular/core';

import {
  SkyMediaQueryService,
  SkyMediaBreakpoints
} from '../media-queries';

import {
  Subscription
} from 'rxjs/Subscription';

const FONTSIZECLASS_SMALL = 'fa-2x';
const FONTSIZECLASS_LARGE = 'fa-3x';


export class SkyActionButtonIconComponent implements OnDestroy {

  
  public iconType: string = '';

  public fontSizeClass: string = FONTSIZECLASS_LARGE;

  private subscription: Subscription;

  constructor(private mediaQueryService: SkyMediaQueryService) {
    this.subscription = this.mediaQueryService.subscribe((args: SkyMediaBreakpoints) => {
      if (args === SkyMediaBreakpoints.xs) {
        this.fontSizeClass = FONTSIZECLASS_SMALL;
      } else {
        this.fontSizeClass = FONTSIZECLASS_LARGE;
      }
    });
  }

  public ngOnDestroy() {
    /* istanbul ignore else */
    /* sanity check */
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-action-button-icon',
  styles: [`.sky-action-button-icon-container {
  display: inline-block;
}

@media (max-width: 767px) {
  .sky-action-button-icon-container {
    margin-left: 5px;
    margin-right: 5px;
  }
}

@media (min-width: 768px) {
  .sky-action-button-icon-container {
    display: block;
    margin-bottom: 20px;
  }
}

.sky-action-button-icon {
  color: #007ca6;
}
`],
  template: `<span class="sky-action-button-icon-container">
  <i
    class="fa sky-action-button-icon"
    [ngClass]="['fa-' + iconType, fontSizeClass]">
  </i>
</span>
`
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: SkyMediaQueryService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'iconType': [{ type: Input },],
};
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
